/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import router from '@/router';

import { Vue } from 'vue-property-decorator';
import { LivenessProjectEnum, LivenessSceneEnum } from '@/enums/liveness-param';
import { popPageManager } from '@/shared/tools/popPageManager';
import { NativeVo } from '@/vo/Native';
import { Loading } from '@/shared/utils/loading';
import { setPageTitle } from '@/api/native/utils';
import platform from '@/shared/utils/platform';

import { LivenessLaunchResponseType } from '@hb/liveness/src/api/liveness/types';
import LivenessPop from './LivenessPop';
import { LivenessCheckCode } from './typeEnum';
import { getAppLivenessLaunchTransaction } from './service';

let instance: LivenessPop;

export const livenessPop = {
  // 传入活体识别所需参数，返回Promise形式的活体识别orderId
  getOrderId(
    params: NativeVo.LivenessParam,
    /** h5活体成功 */
    h5BioSuc?: () => void,
  ): Promise<string> {
    if (!instance) {
      instance = new LivenessPop({
        router,
      }).$mount();
      document.body.appendChild(instance.$el);
    }

    // @ts-ignore
    popPageManager.addShowedPop(instance);
    if (h5BioSuc) {
      return instance.open(params, h5BioSuc);
    }
    return instance.open(params);
  },
  // 前置获取活体识别所需参数
  prefetchTransitionContext(params: NativeVo.LivenessParam): Promise<LivenessLaunchResponseType> {
    return getAppLivenessLaunchTransaction({
      project: params.project || LivenessProjectEnum.ZYQ,
      scene: params.scene || LivenessSceneEnum.Authority,
      systemCode: platform.systemCode,
      ocrAfterLoan: params.ocrAfterLoan || false,
    });
  },

  async ensureLiveness<T>(
    vueInstance: Vue,
    params: {
      func: () => Promise<T>; // 原本需要执行的函数，如果返回700001就进行活体认证
      failed?: () => void; // 用户取消活体认证后的操作
      param: NativeVo.LivenessParam; // 活体认证参数，默认臻有钱授信场景。
    },
  ): Promise<T> {
    return params.func().catch((data) => {
      const isLivenessCheckCode = [LivenessCheckCode.INVIVOEXPIRATION_CODE,
        LivenessCheckCode.NOBIOMETRICIDENTIFICANTION_CODE].indexOf(data.code) >= 0;
      if (isLivenessCheckCode) {
        Loading.clearAll();
        setPageTitle('人脸认证');
        return livenessPop
          .getOrderId({
            project: params.param
              ? params.param.project
              : LivenessProjectEnum.ZYQ,
            scene: params.param
              ? params.param.scene
              : LivenessSceneEnum.Authority,
          },
          () => params.func())
          .then(params.func)
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.error('活体失败信息  ', err);
            if (params.failed) {
              if (platform.isHelloApp || platform.isAlipayMini) {
                params.failed();
              }
            }
            return Promise.reject(new Error('人脸未做'));
          });
      }
      return Promise.reject();
    });
  },
};
